<template>
    <b-container fluid>
        <b-card>
            <b-row>
                <b-col>
                    <app-people-evaluated-filters
                        @filter="onFilter"
                    ></app-people-evaluated-filters>
                </b-col>
            </b-row>
        </b-card>
        <b-row>
            <b-col>
                <app-people-evaluated-list
                    :on-change-page="onChangePage"
                    :table-data="peopleEvaluated"
                ></app-people-evaluated-list>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import appPeopleEvaluatedList from './PeopleEvaluatedList'
import appPeopleEvaluatedFilters from './PeopleEvaluatedFilters'
export default {
    components: {
        appPeopleEvaluatedList,
        appPeopleEvaluatedFilters,
    },
    data: () => ({
        page: 1,
        peopleEvaluated: [],
        filters: '',
        currentEvaluationId: '',
    }),
    methods: {
        async loadPeopleEvaluated(evaluationId) {
            if (evaluationId) {
                this.currentEvaluationId = evaluationId
            }
            const params = {
                page: this.page,
                ...this.filters,
            }
            const { data } = await repo.get(
                `performance-evaluations/${this.currentEvaluationId}/load-evaluated-people`,
                params
            )
            this.peopleEvaluated = data
        },
        onChangePage(page) {
            this.page = page
            this.loadPeopleEvaluated()
        },
        onFilter(filters) {
            this.filters = filters
            this.loadPeopleEvaluated()
        },
    },
}
</script>
